/**
 * Buying guide: first-step category radios (values switches / sockets / both; subset
 * may be rendered) and optional second step (kew / grove) drive visibility of
 * [data-buying-guide-segment] blocks.
 */
(function () {
  function setMode(mode) {
    if (!mode || mode === 'none') {
      document.documentElement.removeAttribute('data-buying-guide-mode');
    } else {
      document.documentElement.setAttribute('data-buying-guide-mode', mode);
    }
  }

  function setRange(range) {
    if (!range || range === 'none') {
      document.documentElement.removeAttribute('data-buying-guide-range');
    } else {
      document.documentElement.setAttribute('data-buying-guide-range', range);
    }
  }

  function categoryMatches(mode, segmentCat) {
    if (!mode || mode === 'none') return false;
    if (mode === 'both') return true;
    return mode === segmentCat;
  }

  function rangeMatches(htmlRange, el) {
    var segRange = el.getAttribute('data-buying-guide-range');
    if (!segRange) return true;
    if (!htmlRange) return false;
    return htmlRange === segRange;
  }

  function applySegmentVisibility() {
    var mode = document.documentElement.getAttribute('data-buying-guide-mode');
    var range = document.documentElement.getAttribute('data-buying-guide-range');

    var wrapperState = new Map();

    document.querySelectorAll('[data-buying-guide-segment]').forEach(function (el) {
      var seg = el.getAttribute('data-buying-guide-segment');
      var catOk = categoryMatches(mode, seg);
      var rangeOk = rangeMatches(range, el);
      var ok = catOk && rangeOk;
      el.classList.toggle('is-buying-guide-visible', ok);

      // Hide/show the whole section wrapper too, so section-level padding/margins
      // don't leave empty gaps when a segment is hidden.
      var wrapper = el.closest('[id^="shopify-section-"]');
      if (wrapper) {
        var prev = wrapperState.get(wrapper) || false;
        wrapperState.set(wrapper, prev || ok);
      }
    });

    wrapperState.forEach(function (ok, wrapper) {
      wrapper.classList.toggle('is-buying-guide-section-visible', ok);
      wrapper.classList.toggle('is-buying-guide-section-hidden', !ok);
    });

    /* “Both” + Kew/Grove: switches and sockets use the same range intro — hide the duplicate sockets banner only */
    if (mode === 'both' && range) {
      document
        .querySelectorAll('[id^="shopify-section-"].section-buying-guide-range-banner')
        .forEach(function (section) {
          var dup = section.querySelector(
            '[data-buying-guide-segment="sockets"][data-buying-guide-range="' + range + '"]'
          );
          if (!dup) return;
          dup.classList.remove('is-buying-guide-visible');
          section.classList.remove('is-buying-guide-section-visible');
          section.classList.add('is-buying-guide-section-hidden');
        });
    }

    // Segments use display:none until visible; re-run fade-up observer after layout
    if (typeof window.initFadeUpInView === 'function') {
      requestAnimationFrame(function () {
        window.initFadeUpInView();
      });
    }
  }

  function init() {
    var root = document.querySelector('[data-buying-guide-picker]');
    if (!root || root.getAttribute('data-buying-guide-bound') === '1') return;
    root.setAttribute('data-buying-guide-bound', '1');

    var twoStep = root.getAttribute('data-buying-guide-two-step') === 'true';
    var skipLineStep = root.getAttribute('data-buying-guide-skip-line-step') === 'true';
    var fixedRange = root.getAttribute('data-buying-guide-fixed-range') || 'kew';
    var catName = root.getAttribute('data-radio-name') || 'buying-guide-category';
    var lineName = root.getAttribute('data-radio-name-line') || 'buying-guide-line';

    var step1 = root.querySelector('[data-buying-guide-step="1"]');
    var step2 = root.querySelector('[data-buying-guide-step="2"]');
    var btnNext1 = root.querySelector('[data-buying-guide-next="1"]');
    var btnSubmit = root.querySelector('[data-buying-guide-submit]');
    var btnBack = root.querySelector('[data-buying-guide-back]');

    var STEP_CLS = {
      leaveNext: 'buying-guide-picker__step--leave-next',
      leaveBack: 'buying-guide-picker__step--leave-back',
      preEnter: 'buying-guide-picker__step--pre-enter',
      enterNext: 'buying-guide-picker__step--enter-next',
      enterBack: 'buying-guide-picker__step--enter-back',
    };
    var stepTransitionLock = false;

    function prefersReducedMotion() {
      return (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    function clearStepMotionClasses(el) {
      if (!el) return;
      el.classList.remove(
        STEP_CLS.leaveNext,
        STEP_CLS.leaveBack,
        STEP_CLS.preEnter,
        STEP_CLS.enterNext,
        STEP_CLS.enterBack
      );
    }

    function readCategory() {
      var checked = root.querySelector(
        'input[type="radio"][name="' + catName + '"]:checked'
      );
      return checked ? checked.value : null;
    }

    function readLine() {
      var checked = root.querySelector(
        'input[type="radio"][name="' + lineName + '"]:checked'
      );
      return checked ? checked.value : null;
    }

    function applyStepVisibility(n) {
      if (step1) {
        step1.hidden = n !== 1;
        step1.setAttribute('aria-hidden', n === 1 ? 'false' : 'true');
      }
      if (step2) {
        step2.hidden = n !== 2;
        step2.setAttribute('aria-hidden', n === 2 ? 'false' : 'true');
      }
    }

    /**
     * @param {1|2} n
     * @param {{ animate?: boolean, direction?: 'next'|'back' }} [opts]
     */
    function showStep(n, opts) {
      opts = opts || {};
      var useMotion =
        opts.animate === true && twoStep && step1 && step2 && !prefersReducedMotion();

      if (!useMotion) {
        clearStepMotionClasses(step1);
        clearStepMotionClasses(step2);
        applyStepVisibility(n);
        return;
      }

      var outgoing = n === 1 ? step2 : step1;
      var incoming = n === 1 ? step1 : step2;
      var dir = opts.direction || (n === 2 ? 'next' : 'back');
      var leaveClass = dir === 'next' ? STEP_CLS.leaveNext : STEP_CLS.leaveBack;
      var enterClass = dir === 'next' ? STEP_CLS.enterNext : STEP_CLS.enterBack;
      var enterKeyframe =
        dir === 'next' ? 'buying-guide-picker-step-in-next' : 'buying-guide-picker-step-in-back';

      if (incoming && !incoming.hidden) {
        return;
      }
      if (stepTransitionLock) {
        return;
      }
      stepTransitionLock = true;
      var leaveHandled = false;
      var enterHandled = false;

      var fallbackTimer = window.setTimeout(function () {
        outgoing.removeEventListener('transitionend', onLeaveEnd);
        incoming.removeEventListener('animationend', onEnterEnd);
        clearStepMotionClasses(outgoing);
        clearStepMotionClasses(incoming);
        applyStepVisibility(n);
        stepTransitionLock = false;
      }, 700);

      function done() {
        window.clearTimeout(fallbackTimer);
        stepTransitionLock = false;
      }

      function onEnterEnd(e) {
        if (enterHandled) return;
        if (e.target !== incoming) return;
        if (e.animationName !== enterKeyframe) return;
        enterHandled = true;
        incoming.removeEventListener('animationend', onEnterEnd);
        incoming.classList.remove(enterClass);
        done();
      }

      function onLeaveEnd(e) {
        if (leaveHandled) return;
        if (e.target !== outgoing) return;
        if (e.propertyName !== 'opacity' && e.propertyName !== 'transform') return;
        leaveHandled = true;
        outgoing.removeEventListener('transitionend', onLeaveEnd);

        outgoing.hidden = true;
        outgoing.setAttribute('aria-hidden', 'true');
        outgoing.classList.remove(leaveClass);
        clearStepMotionClasses(outgoing);

        incoming.hidden = false;
        incoming.setAttribute('aria-hidden', 'false');
        clearStepMotionClasses(incoming);
        incoming.classList.add(STEP_CLS.preEnter);

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            incoming.classList.remove(STEP_CLS.preEnter);
            incoming.classList.add(enterClass);
            incoming.addEventListener('animationend', onEnterEnd);
          });
        });
      }

      outgoing.addEventListener('transitionend', onLeaveEnd);
      outgoing.classList.add(leaveClass);
    }

    function revealContent() {
      var cat = readCategory();
      var line = readLine();
      if (!cat || !line) return;
      setMode(cat);
      setRange(line);
      applySegmentVisibility();
    }

    function hideContent() {
      setMode(null);
      setRange(null);
      applySegmentVisibility();
    }

    function syncLineSubmitState() {
      if (!btnSubmit) return;
      btnSubmit.disabled = !readLine();
    }

    function syncStep1NextState() {
      if (!btnNext1) return;
      btnNext1.disabled = !readCategory();
    }

    function scrollToFirstVisibleSegment() {
      var first = document.querySelector('[data-buying-guide-segment].is-buying-guide-visible');
      if (first && typeof first.scrollIntoView === 'function') {
        requestAnimationFrame(function () {
          first.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    function dismissLineTooltips() {
      root.querySelectorAll('.tooltip-wrapper .tooltip-trigger').forEach(function (btn) {
        btn.blur();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dismissLineTooltips();
    });

    if (skipLineStep) {
      if (step1) {
        step1.hidden = false;
        step1.setAttribute('aria-hidden', 'false');
      }
      hideContent();

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio') return;
        if (t.name === catName) {
          hideContent();
          syncStep1NextState();
        }
      });

      syncStep1NextState();

      if (btnNext1) {
        btnNext1.addEventListener('click', function () {
          if (!readCategory()) return;
          setMode(readCategory());
          setRange(fixedRange);
          applySegmentVisibility();
          scrollToFirstVisibleSegment();
        });
      }
    } else if (twoStep) {
      showStep(1, { animate: false });
      hideContent();

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio') return;
        if (t.name === lineName) {
          hideContent();
          syncLineSubmitState();
          return;
        }
        if (t.name === catName) {
          hideContent();
          syncStep1NextState();
        }
      });

      syncStep1NextState();

      if (btnNext1) {
        btnNext1.addEventListener('click', function () {
          if (!readCategory()) return;
          showStep(2, { animate: true, direction: 'next' });
          hideContent();
          dismissLineTooltips();
          root.querySelectorAll('input[name="' + lineName + '"]').forEach(function (inp) {
            inp.checked = false;
          });
          syncLineSubmitState();
        });
      }

      if (btnSubmit) {
        btnSubmit.addEventListener('click', function () {
          if (!readCategory() || !readLine()) return;
          revealContent();
          scrollToFirstVisibleSegment();
        });
      }

      if (btnBack) {
        btnBack.addEventListener('click', function () {
          root.querySelectorAll('input[name="' + lineName + '"]').forEach(function (inp) {
            inp.checked = false;
          });
          showStep(1, { animate: true, direction: 'back' });
          hideContent();
          dismissLineTooltips();
          syncLineSubmitState();
          syncStep1NextState();
        });
      }
    } else {
      if (step1) {
        step1.hidden = false;
        step1.setAttribute('aria-hidden', 'false');
      }
      setMode(readCategory());
      setRange(null);
      applySegmentVisibility();

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.name === catName && t.type === 'radio') {
          setMode(t.value);
          setRange(null);
          applySegmentVisibility();
        }
      });
    }

  }

  document.addEventListener('shopify:section:load', function () {
    applySegmentVisibility();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
